import { JobType } from '@/enum'
import type { IVendor } from '@/interfaces'
import type { IMillOrderJobForm } from '@/interfaces/jobs/mill-orders/IMillOrderJobForm'
import { Vendor } from '@/models/vendors'
import JobForm from '@/models/jobs/JobForm'
import type JobAssignedEmployeeUpdate from '../JobAssignedEmployeeUpdate'

class MillOrderJobForm extends JobForm implements IMillOrderJobForm {
  workOrderVendorId: string
  workOrderUrl: string
  workOrderVendor: IVendor
  firstEmployee: any;
  secondEmployee: any;

  constructor(jobForm?: any) {
    super(jobForm)
    this.type = JobType.MILL_ORDER
    this.workOrderVendorId = jobForm?.workOrderVendorId
    this.workOrderUrl = jobForm?.workOrderUrl
    this.workOrderVendor = new Vendor(jobForm?.workOrderVendor)

    if (jobForm?.assignedEmployees?.length > 0) {
      this.firstEmployee = jobForm?.assignedEmployees.filter((e: JobAssignedEmployeeUpdate) => e.order == 1)?.[0]?.employeeId ?? null;
      this.secondEmployee = jobForm?.assignedEmployees.filter((e: JobAssignedEmployeeUpdate) => e.order == 2)?.[0]?.employeeId ?? null;
    }
  }
}

export default MillOrderJobForm
